import { render, staticRenderFns } from "./mxDownload.vue?vue&type=template&id=656968d7&scoped=true"
import script from "./mxDownload.vue?vue&type=script&lang=js"
export * from "./mxDownload.vue?vue&type=script&lang=js"
import style0 from "./mxDownload.vue?vue&type=style&index=0&id=656968d7&prod&lang=less&scoped=true"
import style1 from "./mxDownload.vue?vue&type=style&index=1&id=656968d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656968d7",
  null
  
)

export default component.exports